import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { t } from "../../i18next"
import DamageCaseIcon from "../../images/icons/damage_case-104.png"
import { BackNavigator, LhoHeaderText, PageHeader, PosedAppContent } from "../common"
import { startCase } from "../damage-case/redux/actions"

import * as actions from "./redux/actions"
import WithLgDetail from "./WithLgDetail"
import { HousesDrilldown, LhoActions } from "."

export class LhoPropertyPage extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    drillUp: PropTypes.bool,
    propertyRef: PropTypes.string.isRequired,
    property: PropTypes.object,
  }

  render() {
    const { propertyRef, property } = this.props

    return (
      <div className="lho-explorer-lho-property-page">
        <PageHeader>
          <BackNavigator url="/" />
          <div className="header-text">
            <LhoHeaderText lhoRef={propertyRef} property={property} />
          </div>
        </PageHeader>

        <PosedAppContent
          className="app-content"
          initialPose={this.props.drillUp ? "unmountedUp" : "unmountedDown"}
          pose={"mounted"}
        >
          {this.renderDetail()}
        </PosedAppContent>
      </div>
    )
  }

  renderDetail() {
    const { propertyRef, property } = this.props
    const { startCase } = this.props.actions

    if (property) {
      return [
        <div key="0" className="app-content_middle">
          <LhoActions className="property-actions">
            <button className="lho-action-button" onClick={() => startCase(property.reference)}>
              <img className="icon icon-damage_case" alt={t("damageCase.title")} src={DamageCaseIcon} />
            </button>
          </LhoActions>
        </div>,
        <WithLgDetail key="1" propertyRef={propertyRef}>
          <HousesDrilldown className="app-content_right" houses={property.houses || []} />
        </WithLgDetail>,
      ]
    } else {
      return <div className="lg-detail-missing-message">{t("lho.noPropertyFound", { ref: this.lhoRef() })}</div>
    }
  }

  lhoRef() {
    return this.props.propertyRef
  }
}

/* istanbul ignore next */
function mapStateToProps(state, ownProps) {
  const { propertyRef } = ownProps.match.params
  const lhoData = state.home && state.home.lhoData

  const properties = lhoData && lhoData.properties
  const property = properties && properties.find(p => p.reference === propertyRef)

  const drillUp = state.router.location.drillUp

  return {
    drillUp,
    propertyRef,
    property,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, startCase }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LhoPropertyPage)



// WEBPACK FOOTER //
// ./src/features/lho-explorer/LhoPropertyPage.js